import { useEffect, useState } from "react"
import { IoRadioButtonOff, IoRadioButtonOnSharp } from "react-icons/io5"
import { GoCalendar } from "react-icons/go"
import { format } from "date-fns"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import id from 'date-fns/locale/id'
import SettingTitleBox from "../../components/SettingTitleBox";
import SettingSideBox from "../../components/SettingSideBox";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const ProfileFormBox = () => {

  const [form, setForm] = useState({
    fullName: '',
    email: 'jatikusuma0801@gmail.com',
    jenisKelamin: null,
    birthDay: null,
    noHp: ''
  })

  return (
    <div
      className="p-5 py-8 rounded-lg bg-white space-y-5"
      style={{
        width: '469px',
        fontSize: '13px'
      }}
    >
      <div className="space-y-1">
        <div
        >
          Nama Lengkap
        </div>
        <div>
          <input 
            className="w-full p-1.5 rounded-sm border border-gray-300 outline-green-500"
            value={form.fullName}
            onChange={(e) => setForm({ ...form, fullName: e.target.value })}
          />
        </div>
      </div>
      <div className="space-y-1">
        <div
        >
          Email
        </div>
        <div>
          <input 
            className="w-full p-1.5 rounded-sm border border-gray-300 outline-green-500"
            value={form.email}
            readOnly
          />
        </div>
      </div>
      <div className="space-y-1">
        <div
        >
          Tanggal lahir (dd/MM/yyyy)
        </div>
        <div className="flex items-center">
          <div className="h-9 flex items-center px-1 border-t border-l border-b border-gray-400">
            <GoCalendar />
          </div>
          <DatePicker
            className="border border-gray-400 p-1 w-full h-9 outline-green-500" 
            selected={form.birthDay} 
            onChange={(date) => setForm({ ...form, birthDay: date })} 
            dateFormat="dd/MM/yyyy"
          />
        </div>
      </div>
      <div className="space-y-1">
        <div
        >
          Jenis Kelamin
        </div>
        <div
          className="flex space-x-5"
        >
          <div
            className=""
          >
            <button
              className="flex items-center space-x-2"
              onClick={() => setForm({ ...form, jenisKelamin: 'lakilaki' })}
            >
              {
                form.jenisKelamin === 'lakilaki' ?
                  <IoRadioButtonOnSharp className="h-5 w-5 text-green-700"/>
                  :
                  <IoRadioButtonOff className="h-5 w-5 text-green-700"/>
              }
              <label className="cursor-pointer">Laki-laki</label>
            </button>
          </div>
          <div
            className=""
          >
            <button
              className="flex items-center space-x-2"
              onClick={() => setForm({ ...form, jenisKelamin: 'perempuan' })}
            >
              {
                form.jenisKelamin === 'perempuan' ?
                  <IoRadioButtonOnSharp className="h-5 w-5 text-green-700"/>
                  :
                  <IoRadioButtonOff className="h-5 w-5 text-green-700"/>
              }
              <label className="cursor-pointer">Perempuan</label>
            </button>
          </div>
        </div>
      </div>
      <div
        className="space-y-1"
      >
        <div
        >
          No. HP
        </div>
        <div className="relative">
          <input 
            type={'number'}
            className="w-full p-1.5 pl-12 border border-gray-300 rounded-md outline-green-300"
            style={{
              fontSize: '14px'
            }}
            value={form.noHp}
            onChange={e => setForm({ ...form, noHp: e.target.value })}
          />
          <div 
            class="flex absolute w-10 inset-y-0 left-0 items-center justify-center border-r border-gray-300"
            style={{
              fontSize: '14px'
            }}
          >
            +62
          </div>
        </div>
      </div>
      <div>
        <button
          className="w-full py-1.5 bg-green-800 text-white font-bold rounded-md"
        >
          SIMPAN
        </button>
      </div>
    </div>
  )

}

const SettingProfilePage = () => {
  useEffect(() => {
    document.body.style.backgroundColor = '#232745';
  }, []);

  return (
    <>
    <Navbar />
    <div
      className="w-full space-y-10"
      style={{
        backgroundColor: '#232745',
        minHeight: '800px'
      }}
    >
      <SettingTitleBox
        title={'Edit Akun'}
      />
      <div
        className="flex justify-center"
        style={{
          backgroundColor: '#232745'
        }}
      >
        <div
          className="flex space-x-5"
          style={{
            width: '1199px'
          }}
        >
          
          <SettingSideBox 
            activeMenu={'profile'}
          />
          <div className="flex-1">
            <ProfileFormBox />
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  )
}

export default SettingProfilePage;